<template>
  <div>
    <b-modal
      id="filter"
      size="md"
      no-close-on-backdrop
      hide-footer
      title="FILTRAR"
    >
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <label>FILTRAR POR FORMULÁRIO</label>
          <select v-model="form_id" class="form-control">
            <option value="ALL">TODOS</option>

            <option v-for="form in forms" :key="form.id" :value="form.id">
              {{ String(form.name).toUpperCase() }}
            </option>
          </select>
        </div>

        <div class="col-xl-12 col-sm-12 col-md-6 col-sm-12 col-12">
          <label>Filtrar por data inicial:</label>

          <input type="date" v-model="dtInit" class="form-control" />
        </div>

        <div class="col-xl-12 col-sm-12 col-md-6 col-sm-12 col-12">
          <label>Filtrar por data final:</label>

          <input type="date" v-model="dtEnd" class="form-control" />
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn
            :disabled="loading"
            @click="paginate()"
            class="btn-filter"
            type="relief"
            ><i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "FILTRAR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>

    <b-overlay :show="loading" opacity="0.99">
      <div v-if="step == 'FORMS'">
        <b-modal
          size="xl"
          no-close-on-backdrop
          hide-footer
          id="modalAnswer"
          :title="
            form.name
              ? `RESPONDER FORMULÁRIO: ${form.name}`
              : 'RESPONDER FORMULÁRIO'
          "
        >
          <Answer
            :resident_id="resident_id"
            :loadingCreate="loading"
            v-on:success="handleSuccess"
            v-on:form="handleForm"
          />
        </b-modal>

        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0">
            <h1 class="title-pages pl-0">FORMULÁRIOS</h1>
          </div>

          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 text-right pt-0"
          >
            <v-btn
              @click="$bvModal.show('filter')"
              class="btn-filter"
              type="relief"
            >
              <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
            </v-btn>

            <v-btn
              v-if="button_answer"
              @click="handleModalAnswer"
              class="ml-1 btn-acess-dash"
              ><i class="far fa-question-circle mr-2 text-twenty"></i>
              RESPONDER</v-btn
            >
          </div>
        </div>

        <div
          class="v-clean p-5 text-center"
          v-show="semiology_forms.length == 0"
        >
          SEM RESULTADOS!
        </div>

        <v-data-table
          disable-pagination
          hide-default-footer
          v-show="semiology_forms.length > 0"
          :headers="headers"
          :items="semiology_forms"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="clickItem"
        >
          <template v-slot:[`item.technical_user_name`]="{ item }">
            <span v-if="item.technical_responsible == 1" class="validated">
              {{ item.user_name }}
            </span>

            <span v-if="item.technical_responsible == 0" class="not-validated">
              Não validado
            </span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <span v-if="item.status == 'FINALIZADO'" class="validated">
              FINALIZADO
            </span>

            <span v-if="item.status == 'PENDENTE'" class="not-validated">
              PENDENTE
            </span>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}
          </template>
        </v-data-table>

        <div class="mt-5">
          <b-pagination
            align="center"
            v-if="semiology_forms.length > 0"
            @input="paginate()"
            v-model="page"
            :total-rows="total"
            :per-page="10"
          />
        </div>
      </div>

      <div v-if="step == 'FORM'">
        <AnsweredForm
          :resident_id="resident_id"
          :form="formAnswer"
          v-on:clickRowTable="clickRowTable"
          v-on:update="handleUpdate"
          v-on:delete="handleDelete"
        />
      </div>
    </b-overlay>

    <errors-messages :errors="errors" />
  </div>
</template>

<script>
import Answer from "./Answer";

import AnsweredForm from "./AnsweredForm";

import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import routes from "../../../routes";

import { formatDate } from "../../../lib/format";

export default {
  name: "AnsweredForms",

  components: {
    Answer,
    AnsweredForm,
    ErrorsMessages,
  },

  created() {
    this.retrieve();
  },

  props: {
    resident_id: [Number, String],
    button_answer: Boolean,
  },

  data() {
    return {
      loading: false,

      search: "",

      form_id: "ALL",

      step: "FORMS",

      form: {},

      formAnswer: {},

      dtInit: "",

      dtEnd: "",

      forms: [],

      page: 1,

      total: 0,

      semiology_forms: [],

      errors: [],

      headers: [
        { text: "VALIDADO", value: "technical_user_name" },
        { text: "STATUS", value: "status" },
        { text: "NOME", value: "name" },
        { text: "RESPONDIDO POR", value: "user_name" },
        { text: "DATA RESPOSTA", value: "created_at" },
      ],
    };
  },
  methods: {
    formatDate,

    handleUpdate() {
      this.$emit("update");
      this.formAnswer.status = "FINALIZADO";
    },

    handleDelete() {
      this.$emit("delete");
    },

    clickRowTable() {
      this.step = "FORMS";
      this.paginate();
      this.$emit("clickedItem", false);
    },

    handleSuccess() {
      this.$bvModal.hide("modalAnswer");
      this.$emit("update");
      this.paginate();
      this.getForms();
    },

    handleForm({ open, form }) {
      if (open) {
        this.$emit("clickedItem", true);
        this.formAnswer = form;
        this.step = "FORM";
      } else {
        this.answerQuestions(form);
      }
    },

    async answerQuestions({ id }) {
      try {
        this.loading = true;

        const { resident_id } = this;

        let params = { resident_id, id };

        const response = await api.post(
          "/rest-home/answer-semiology/form-open",
          params
        );

        const { error, errors, form } = response.data;

        if (!error) {
          this.$emit("clickedItem", true);
          this.formAnswer = form;
          this.step = "FORM";
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleModalAnswer() {
      this.$bvModal.show("modalAnswer");
    },

    clickItem(item) {
      this.$emit("clickedItem", true);
      this.formAnswer = item;
      this.step = "FORM";
    },

    async retrieve() {
      const { date } = routes.history.current.query;

      if (date) {
        this.dtInit = date;
        this.dtEnd = date;
      }

      if (this.errors.length == 0) await this.paginate();
      if (this.errors.length == 0) await this.getForms();
    },

    async getForms() {
      try {
        const { resident_id } = this;

        var params = { resident_id };

        const response = await api.get("/rest-home/semiology/resident-forms", {
          params,
        });

        const { error, errors, semiology_forms } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.forms = semiology_forms;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, form_id, dtInit, dtEnd, page } = this;

        let params = { resident_id, form_id, dtInit, dtEnd, page };

        let response = await api.get(
          "/rest-home/answer-semiology/answered-forms",
          {
            params,
          }
        );

        let { error, errors, semiology_forms, total } = response.data;
        if (!error) {
          this.errors = [];
          this.semiology_forms = semiology_forms;
          this.total = total;
          this.$bvModal.hide("filter");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
}
</style>
